exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#directory-wrapper{overflow:hidden;-webkit-overflow-scrolling:touch;height:calc(100vh - 48px)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/mobileWrappers/DirectoryWrapper/DirectoryWrapper.scss
// module id = 1864
// module chunks = 0